<div class="modal-header sticky-header d-flex justify-content-between align-items-center">
  <h5 class="modal-title">{{data?.Name}}</h5>
  <div>
    <button type="button" class="btn btn-secondary me-2" (click)="closePopup()"> <i class="fa fa-times"></i> Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="isSaveButtonDisabled" (click)="onSave()"> <i class="fa fa-save"></i> Save</button>
  </div>
</div>
<!-- Tab Buttons -->
<div class="modal-header d-flex mb-3 tabs-sticky sticky-header">
  <button type="button"
          class="btn btn-outline-primary flex-fill me-1"
          [class.active]="activeTab === 'profile'"
          (click)="loadTab('profile')">
    PROFILE
  </button>
  <button type="button"
          class="btn btn-outline-primary flex-fill me-1"
          [class.active]="activeTab === 'notifications'"
          (click)="loadTab('notifications')">
    NOTIFICATIONS
  </button>
  <button type="button"
          class="btn btn-outline-primary flex-fill"
          [class.active]="activeTab === 'saleaccess'"
          (click)="loadTab('saleaccess')">
    SALE ACCESS
  </button>
</div>

<div class="modal-body">


  <!-- Tab Content -->
  <ng-container *ngIf="isProfileLoaded">
    <div [hidden]="activeTab !== 'profile'">
      <app-review-profile-info [data]="data" class="d-flex justify-content-center w-100"></app-review-profile-info>
    </div>
  </ng-container>

  <!-- create notifications only when requested -->
  <ng-container *ngIf="isNotificationsLoaded">
    <div [hidden]="activeTab !== 'notifications'">
      <vet-user-notification-setting [data]="data" [isUseBuiltInSave]="false" [salesCompanyView]="salesCompanyView"></vet-user-notification-setting>
    </div>
  </ng-container>

  <!-- create saleaccess only when requested -->
  <ng-container *ngIf="isSaleAccessLoaded">
    <div [hidden]="activeTab !== 'saleaccess'">
      <app-sale-member-access-popup [data]="data" [isOtherDialog]="true"></app-sale-member-access-popup>
    </div>
  </ng-container>
</div>
